import UIIcon from 'UIComponents/icon/UIIcon';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import { theme } from 'academy-common-lib/utils/Styling';
import UIFlex from 'UIComponents/layout/UIFlex';
import { RouterSelectSingle } from '../../filters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ContentLanguageSelector = ({
  language,
  availableLanguages,
  onLanguageChange
}) => {
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    children: [/*#__PURE__*/_jsx(UIIcon, {
      color: theme.colors.EERIE,
      name: "language",
      size: "xs",
      style: {
        marginTop: 6
      }
    }), /*#__PURE__*/_jsx(RouterSelectSingle, {
      allowList: availableLanguages,
      defaultItem: language.toUpperCase(),
      filterType: FILTER_TYPES.LANGUAGE,
      menuStyle: {
        maxHeight: '270px'
      },
      menuWidth: "auto",
      onFilterChange: onLanguageChange,
      trackingKey: "language-switcher"
    })]
  });
};
export default ContentLanguageSelector;